export default {
    type: 'rating',
    config: {
        fixedWidth: 48
    },
    default: {
        label: 'BGG'
    },
    unique: [],
    sort: 'rating.bgg',
    lang: {
        name: 'Community Rating',
        category: 'BGG',
        description: 'Community average rating of the game.',
        views: ['list', 'sheet', 'grid']
    },
    filters: ['bgg.rating']
}